import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { FilterKey } from '@core/Entities/Search/QueryParams.entity';

const FILTER_CHIP_MARGIN = 12;

const DEFAULT_VISIBLE_NUM = 3;

const CANT_DELETE: { [key in Locale]?: FilterKey[] } = {
  uk: ['postcode', 'sort', 'lat', 'lon'],
  fr: ['sort'],
};

export { CANT_DELETE, FILTER_CHIP_MARGIN, DEFAULT_VISIBLE_NUM };
